"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var baseProps_1 = __importDefault(require("../assets/baseProps"));

var handleEvent_1 = require("../assets/handleEvent");

var View =
/** @class */
function (_super) {
  __extends(View, _super);

  function View() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onDocumentClick = function (_a) {
      var target = _a.target;
      var _b = _this.props,
          onClickSelf = _b.onClickSelf,
          onClickInside = _b.onClickInside,
          onClickOutside = _b.onClickOutside;
      var element = _this.element;

      if (element === target) {
        handleEvent_1.handleEvent(onClickSelf);
        return;
      }

      if (element && element.contains(target)) {
        handleEvent_1.handleEvent(onClickInside);
        return;
      }

      handleEvent_1.handleEvent(onClickOutside);
    };

    return _this;
  }

  View.prototype.componentDidMount = function () {
    document.addEventListener('click', this.onDocumentClick);
  };

  View.prototype.componentWillUnmount = function () {
    document.removeEventListener('click', this.onDocumentClick);
  };

  View.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        className = _a.className,
        style = _a.style;
    return react_1.default.createElement("div", __assign({}, baseProps_1.default(this.props), {
      ref: function ref(element) {
        _this.element = element;
      },
      className: className,
      style: style
    }), children);
  };

  return View;
}(react_1.default.Component);

exports.default = View;